import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { AuthContext } from "providers/Authentication";
import { useTranslation } from "translations";
import { useDefaultRoutePath, useRoutePaths } from "utils";

export default (): null => {
  const { t } = useTranslation("common");
  const getRoutePath = useRoutePaths();
  const navigate = useNavigate();
  const { isLoggedIn } = useContext(AuthContext);
  const defaultRoutePath = useDefaultRoutePath();

  const isTest = [
    "qa.my.payoutpartner.com",
    "rc.my.payoutpartner.com",
    "qa.my.payoutpartner.com",
    "rc.my.payoutpartner.com",
    "localhost",
  ].includes(window.location.hostname);

  useEffect(() => {
    if (isLoggedIn) {
      navigate(defaultRoutePath);
      return;
    }

    if (isTest) {
      navigate(getRoutePath({ module: "login", routeName: "LOGIN" }));
      return;
    }

    window.location.href = t("links.homepage", "https://payoutpartner.com/en");
  }, []);

  return null;
};
